var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 236,
    viewBox: "0 0 236 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_27",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 236,
    height: 236
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236 0H0V236H236V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118 211.613C170.136 211.613 212.4 169.349 212.4 117.213C212.4 65.0778 170.136 22.8133 118 22.8133C65.8646 22.8133 23.6001 65.0778 23.6001 117.213C23.6001 169.349 65.8646 211.613 118 211.613Z",
    fill: "url(#paint0_linear_22_27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5998 49.9974H155.396C162.347 49.9974 167.982 55.6323 167.982 62.5841V159.367C167.982 166.319 162.347 171.954 155.396 171.954H82.5998C75.6481 171.954 70.0132 166.319 70.0132 159.367V62.5841C70.0132 55.6323 75.6481 49.9974 82.5998 49.9974Z",
    fill: "url(#paint1_linear_22_27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5212 65.7308H114.145C116.274 65.7308 118 67.4567 118 69.5854C118 71.7141 116.274 73.4401 114.145 73.4401H82.5212C80.3924 73.4401 78.6665 71.7141 78.6665 69.5854C78.6665 67.4567 80.3924 65.7308 82.5212 65.7308Z",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5212 87.6001H153.479C155.607 87.6001 157.333 89.3261 157.333 91.4548C157.333 93.5835 155.607 95.3095 153.479 95.3095H82.5212C80.3924 95.3095 78.6665 93.5835 78.6665 91.4548C78.6665 89.3261 80.3924 87.6001 82.5212 87.6001Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5212 109.469H153.479C155.607 109.469 157.333 111.195 157.333 113.324C157.333 115.453 155.607 117.179 153.479 117.179H82.5212C80.3924 117.179 78.6665 115.453 78.6665 113.324C78.6665 111.195 80.3924 109.469 82.5212 109.469Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5212 131.339H153.479C155.607 131.339 157.333 133.065 157.333 135.194C157.333 137.322 155.607 139.048 153.479 139.048H82.5212C80.3924 139.048 78.6665 137.322 78.6665 135.194C78.6665 133.065 80.3924 131.339 82.5212 131.339Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5212 153.208H153.479C155.607 153.208 157.333 154.934 157.333 157.063C157.333 159.192 155.607 160.918 153.479 160.918H82.5212C80.3924 160.918 78.6665 159.192 78.6665 157.063C78.6665 154.934 80.3924 153.208 82.5212 153.208Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.62 177.443C155.751 177.443 165.168 174.378 172.992 169.125L205.008 199.688L216.62 186.217L185.726 156.725C191.431 148.694 194.786 138.877 194.786 128.276C194.786 101.123 172.773 79.1096 145.62 79.1096C118.466 79.1096 96.4531 101.123 96.4531 128.276C96.4531 155.43 118.466 177.443 145.62 177.443ZM187.556 128.276C187.556 151.266 168.919 169.902 145.931 169.902C122.942 169.902 104.306 151.266 104.306 128.276C104.306 105.288 122.942 86.6514 145.931 86.6514C168.919 86.6514 187.556 105.288 187.556 128.276Z",
    fill: "#00B5CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.927 170.707C169.605 170.707 188.8 151.688 188.8 128.227C188.8 104.766 169.605 85.7468 145.927 85.7468C122.248 85.7468 103.053 104.766 103.053 128.227C103.053 151.688 122.248 170.707 145.927 170.707Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.006 199.69L216.618 186.218L218.367 187.888C220.064 189.507 221.08 191.77 221.191 194.179C221.303 196.587 220.501 198.943 218.962 200.728C217.422 202.514 215.272 203.583 212.984 203.7C210.696 203.818 208.457 202.974 206.76 201.354L205.011 199.684L205.006 199.69Z",
    fill: "#06759A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.2 149.467C226.807 149.467 228.92 147.354 228.92 144.747C228.92 142.14 226.807 140.027 224.2 140.027C221.593 140.027 219.48 142.14 219.48 144.747C219.48 147.354 221.593 149.467 224.2 149.467Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9288 177.31C46.7713 176.995 47.6579 176.575 48.3415 175.966C49.1533 175.245 49.4837 174.315 49.7048 173.337C49.9895 172.079 50.1036 170.74 50.4489 169.48C50.5764 169.012 50.8226 168.835 50.928 168.757C51.1947 168.559 51.4645 168.506 51.7178 168.526C52.0183 168.549 52.4313 168.669 52.7035 169.199C52.7421 169.275 52.7924 169.391 52.8262 169.549C52.8506 169.665 52.8672 170.028 52.8931 170.178C52.9584 170.547 53.0127 170.916 53.0646 171.287C53.2353 172.521 53.3337 173.57 53.8733 174.704C54.6057 176.243 55.3396 177.185 56.3348 177.603C57.2977 178.006 58.4478 177.93 59.9181 177.614C60.0581 177.578 60.1965 177.548 60.3334 177.523C60.9816 177.404 61.6015 177.851 61.729 178.531C61.8564 179.21 61.4442 179.872 60.8015 180.021C60.6677 180.052 60.5356 180.082 60.405 180.109C58.4179 180.627 56.1177 182.474 54.7811 184.091C54.3697 184.59 53.7663 185.985 53.1511 186.874C52.6972 187.53 52.1867 187.962 51.758 188.116C51.4708 188.219 51.2293 188.202 51.0295 188.15C50.7384 188.076 50.4977 187.91 50.3129 187.646C50.2122 187.502 50.1185 187.309 50.0737 187.062C50.0525 186.944 50.0501 186.642 50.0509 186.505C49.925 186.052 49.7716 185.609 49.6599 185.151C49.3932 184.057 48.8701 183.366 48.2486 182.452C47.6673 181.597 47.0427 181.059 46.127 180.63C46.0082 180.599 45.0469 180.351 44.7078 180.21C44.2122 180.001 43.9755 179.652 43.8897 179.464C43.7442 179.145 43.7292 178.867 43.7583 178.634C43.8016 178.291 43.9479 177.998 44.2075 177.761C44.368 177.614 44.6079 177.471 44.9297 177.401C45.1775 177.346 45.8367 177.315 45.9288 177.31ZM51.5668 175.529C51.6108 175.634 51.6588 175.738 51.7092 175.845C52.7814 178.099 53.9811 179.359 55.4396 179.969L55.4883 179.989C54.5129 180.751 53.6294 181.603 52.9553 182.42C52.6768 182.756 52.3094 183.455 51.9114 184.171C51.5503 182.936 50.9603 182.062 50.2177 180.969C49.6497 180.135 49.0558 179.507 48.3249 178.996C48.8921 178.69 49.4326 178.331 49.9038 177.913C50.6881 177.215 51.2065 176.407 51.5668 175.529Z",
    fill: "#CCC6D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_27",
    x1: 117.27,
    y1: -7.92558,
    x2: 119.204,
    y2: 323.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22_27",
    x1: 118.998,
    y1: 49.9974,
    x2: 118.998,
    y2: 171.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7188,
    stopColor: "#FAFAFA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.1cb894ac.svg";
export { ForwardRef as ReactComponent };